// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file api/v1/valuation_service.proto (package journal.api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_api_annotations } from "../../google/api/annotations_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/v1/valuation_service.proto.
 */
export const file_api_v1_valuation_service: GenFile = /*@__PURE__*/
  fileDesc("Ch5hcGkvdjEvdmFsdWF0aW9uX3NlcnZpY2UucHJvdG8SDmpvdXJuYWwuYXBpLnYxIrwBChNVc2VyVmFsdWF0aW9uQ29uZmlnEgoKAmlkGAEgASgJEg8KB3VzZXJfaWQYAiABKAkSEQoJdGlja2VyX2lkGAMgASgJEhcKD2lkZWFsX2J1eV9wcmljZRgEIAEoARIYChBpZGVhbF9zZWxsX3ByaWNlGAUgASgBEhgKEHJlYXNvbmFibGVfcHJpY2UYBiABKAESEwoLY3JlYXRlX3RpbWUYByABKAMSEwoLdXBkYXRlX3RpbWUYCCABKAMiLQodR2V0VXNlclZhbHVhdGlvbkNvbmZpZ1JlcXVlc3QSDAoEbmFtZRgBIAEoCSJlCh5HZXRVc2VyVmFsdWF0aW9uQ29uZmlnUmVzcG9uc2USMwoGY29uZmlnGAEgASgLMiMuam91cm5hbC5hcGkudjEuVXNlclZhbHVhdGlvbkNvbmZpZxIOCgZleGlzdHMYAiABKAgiVQoeU2F2ZVVzZXJWYWx1YXRpb25Db25maWdSZXF1ZXN0EjMKBmNvbmZpZxgBIAEoCzIjLmpvdXJuYWwuYXBpLnYxLlVzZXJWYWx1YXRpb25Db25maWcyzgIKEFZhbHVhdGlvblNlcnZpY2USpAEKFkdldFVzZXJWYWx1YXRpb25Db25maWcSLS5qb3VybmFsLmFwaS52MS5HZXRVc2VyVmFsdWF0aW9uQ29uZmlnUmVxdWVzdBouLmpvdXJuYWwuYXBpLnYxLkdldFVzZXJWYWx1YXRpb25Db25maWdSZXNwb25zZSIrgtPkkwIlEiMvYXBpL3YxL3ZhbHVhdGlvbnMve25hbWU9dGlja2Vycy8qfRKSAQoXU2F2ZVVzZXJWYWx1YXRpb25Db25maWcSLi5qb3VybmFsLmFwaS52MS5TYXZlVXNlclZhbHVhdGlvbkNvbmZpZ1JlcXVlc3QaIy5qb3VybmFsLmFwaS52MS5Vc2VyVmFsdWF0aW9uQ29uZmlnIiKC0+STAhw6BmNvbmZpZyISL2FwaS92MS92YWx1YXRpb25zQroBChJjb20uam91cm5hbC5hcGkudjFCFVZhbHVhdGlvblNlcnZpY2VQcm90b1ABWjNnaXRodWIuY29tL3hpbmdodWkvdmFsdWF0aW9uL3Byb3RvL2dlbi9hcGkvdjE7YXBpdjGiAgNKQViqAg5Kb3VybmFsLkFwaS5WMcoCDkpvdXJuYWxcQXBpXFYx4gIaSm91cm5hbFxBcGlcVjFcR1BCTWV0YWRhdGHqAhBKb3VybmFsOjpBcGk6OlYxYgZwcm90bzM", [file_google_api_annotations]);

/**
 * UserValuationConfig holds user's valuation configuration for a ticker
 *
 * @generated from message journal.api.v1.UserValuationConfig
 */
export type UserValuationConfig = Message<"journal.api.v1.UserValuationConfig"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string ticker_id = 3;
   */
  tickerId: string;

  /**
   * Manual buy/sell points
   *
   * @generated from field: double ideal_buy_price = 4;
   */
  idealBuyPrice: number;

  /**
   * @generated from field: double ideal_sell_price = 5;
   */
  idealSellPrice: number;

  /**
   * @generated from field: double reasonable_price = 6;
   */
  reasonablePrice: number;

  /**
   * Metadata
   *
   * @generated from field: int64 create_time = 7;
   */
  createTime: bigint;

  /**
   * @generated from field: int64 update_time = 8;
   */
  updateTime: bigint;
};

/**
 * Describes the message journal.api.v1.UserValuationConfig.
 * Use `create(UserValuationConfigSchema)` to create a new message.
 */
export const UserValuationConfigSchema: GenMessage<UserValuationConfig> = /*@__PURE__*/
  messageDesc(file_api_v1_valuation_service, 0);

/**
 * @generated from message journal.api.v1.GetUserValuationConfigRequest
 */
export type GetUserValuationConfigRequest = Message<"journal.api.v1.GetUserValuationConfigRequest"> & {
  /**
   * Format: "tickers/{symbol}"
   *
   * @generated from field: string name = 1;
   */
  name: string;
};

/**
 * Describes the message journal.api.v1.GetUserValuationConfigRequest.
 * Use `create(GetUserValuationConfigRequestSchema)` to create a new message.
 */
export const GetUserValuationConfigRequestSchema: GenMessage<GetUserValuationConfigRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_valuation_service, 1);

/**
 * @generated from message journal.api.v1.GetUserValuationConfigResponse
 */
export type GetUserValuationConfigResponse = Message<"journal.api.v1.GetUserValuationConfigResponse"> & {
  /**
   * @generated from field: journal.api.v1.UserValuationConfig config = 1;
   */
  config?: UserValuationConfig;

  /**
   * True if user has saved config before
   *
   * @generated from field: bool exists = 2;
   */
  exists: boolean;
};

/**
 * Describes the message journal.api.v1.GetUserValuationConfigResponse.
 * Use `create(GetUserValuationConfigResponseSchema)` to create a new message.
 */
export const GetUserValuationConfigResponseSchema: GenMessage<GetUserValuationConfigResponse> = /*@__PURE__*/
  messageDesc(file_api_v1_valuation_service, 2);

/**
 * @generated from message journal.api.v1.SaveUserValuationConfigRequest
 */
export type SaveUserValuationConfigRequest = Message<"journal.api.v1.SaveUserValuationConfigRequest"> & {
  /**
   * @generated from field: journal.api.v1.UserValuationConfig config = 1;
   */
  config?: UserValuationConfig;
};

/**
 * Describes the message journal.api.v1.SaveUserValuationConfigRequest.
 * Use `create(SaveUserValuationConfigRequestSchema)` to create a new message.
 */
export const SaveUserValuationConfigRequestSchema: GenMessage<SaveUserValuationConfigRequest> = /*@__PURE__*/
  messageDesc(file_api_v1_valuation_service, 3);

/**
 * @generated from service journal.api.v1.ValuationService
 */
export const ValuationService: GenService<{
  /**
   * GetUserValuationConfig gets user's valuation config for a ticker
   *
   * @generated from rpc journal.api.v1.ValuationService.GetUserValuationConfig
   */
  getUserValuationConfig: {
    methodKind: "unary";
    input: typeof GetUserValuationConfigRequestSchema;
    output: typeof GetUserValuationConfigResponseSchema;
  },
  /**
   * SaveUserValuationConfig saves or updates user's valuation config
   *
   * @generated from rpc journal.api.v1.ValuationService.SaveUserValuationConfig
   */
  saveUserValuationConfig: {
    methodKind: "unary";
    input: typeof SaveUserValuationConfigRequestSchema;
    output: typeof UserValuationConfigSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_v1_valuation_service, 0);

